import * as Types from '../../../../../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ProductHeroContentFieldsFragment = {
  __typename?: 'ProductHeroContent';
  id: string;
  title: string;
  eyebrow: string;
  description: string;
  watchVideoUrl?: string | null;
  gradientCustomColorValue?: string | null;
  textCustomColorValue?: string | null;
  storefront: Types.CatalogStorefront;
  horizontalAlignment: Types.ProductHeroHorizontalAlignment;
  gradientMode: Types.ProductHeroGradientMode;
  textColorMode: Types.ProductHeroTextColorMode;
  cta: { __typename?: 'ProductHeroContentCta'; text: string; publicUrlPath: string; redirectUrlType: Types.ProductHeroRedirectUrlType };
  desktopMedia:
    | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
    | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
  tabletMedia:
    | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
    | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
  mobileMedia:
    | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
    | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
};

export type ProductHeroContentByCriteriaQueryVariables = Types.Exact<{
  criteria: Types.ProductHeroContentInputCriteria;
}>;

export type ProductHeroContentByCriteriaQuery = {
  __typename?: 'Query';
  productHeroContentByCriteria: Array<{
    __typename?: 'ProductHeroContent';
    id: string;
    title: string;
    eyebrow: string;
    description: string;
    watchVideoUrl?: string | null;
    gradientCustomColorValue?: string | null;
    textCustomColorValue?: string | null;
    storefront: Types.CatalogStorefront;
    horizontalAlignment: Types.ProductHeroHorizontalAlignment;
    gradientMode: Types.ProductHeroGradientMode;
    textColorMode: Types.ProductHeroTextColorMode;
    cta: { __typename?: 'ProductHeroContentCta'; text: string; publicUrlPath: string; redirectUrlType: Types.ProductHeroRedirectUrlType };
    desktopMedia:
      | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
      | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
    tabletMedia:
      | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
      | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
    mobileMedia:
      | { __typename?: 'ProductHeroImage'; photo: { __typename?: 'ProductHeroImagePhotoAsset'; image: { __typename?: 'Photo'; id: string; url: string } } }
      | { __typename?: 'ProductHeroVideo'; video: { __typename?: 'ProductHeroVideoAsset'; videoUrl: string; fallbackImage: { __typename?: 'Photo'; id: string; url: string } } };
  }>;
};

export const ProductHeroContentFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductHeroContentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eyebrow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'watchVideoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientCustomColorValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textCustomColorValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storefront' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalAlignment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textColorMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUrlType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tabletMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const ProductHeroContentByCriteriaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ProductHeroContentByCriteria' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroContentInputCriteria' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productHeroContentByCriteria' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'criteria' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'criteria' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ProductHeroContentFields' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ProductHeroContentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroContent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eyebrow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'watchVideoUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientCustomColorValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textCustomColorValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storefront' } },
          { kind: 'Field', name: { kind: 'Name', value: 'horizontalAlignment' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gradientMode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'textColorMode' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicUrlPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUrlType' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tabletMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileMedia' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroImage' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProductHeroVideo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'videoUrl' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fallbackImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useProductHeroContentByCriteriaQuery__
 *
 * To run a query within a React component, call `useProductHeroContentByCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductHeroContentByCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductHeroContentByCriteriaQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useProductHeroContentByCriteriaQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>,
) {
  return ApolloReactHooks.useQuery<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>(ProductHeroContentByCriteriaDocument, baseOptions);
}
export function useProductHeroContentByCriteriaLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>(ProductHeroContentByCriteriaDocument, baseOptions);
}
export type ProductHeroContentByCriteriaQueryHookResult = ReturnType<typeof useProductHeroContentByCriteriaQuery>;
export type ProductHeroContentByCriteriaLazyQueryHookResult = ReturnType<typeof useProductHeroContentByCriteriaLazyQuery>;
export type ProductHeroContentByCriteriaQueryResult = Apollo.QueryResult<ProductHeroContentByCriteriaQuery, ProductHeroContentByCriteriaQueryVariables>;
